import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import GlobalHeader from "./GlobalHeader";
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var getClassName, leftItemsNode, rightItemsNode, isLeftItemsList, leftItems, rightItems, rehydratedProps;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getClassName = getClassNameFactory("GlobalHeader");
            leftItemsNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "leftItems"
            })));
            rightItemsNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "rightItems"
            })));
            isLeftItemsList = (leftItemsNode === null || leftItemsNode === void 0 ? void 0 : leftItemsNode.tagName) === "UL";

            if (!leftItemsNode) {
              _context.next = 10;
              break;
            }

            _context.next = 7;
            return rehydrateChildren(leftItemsNode);

          case 7:
            _context.t0 = _context.sent;
            _context.next = 11;
            break;

          case 10:
            _context.t0 = null;

          case 11:
            leftItems = _context.t0;

            if (!rightItemsNode) {
              _context.next = 18;
              break;
            }

            _context.next = 15;
            return rehydrateChildren(rightItemsNode);

          case 15:
            _context.t1 = _context.sent;
            _context.next = 19;
            break;

          case 18:
            _context.t1 = null;

          case 19:
            rightItems = _context.t1;
            rehydratedProps = {
              isLeftItemsList: isLeftItemsList,
              leftItems: leftItems,
              rightItems: rightItems
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(GlobalHeader, rehydratedProps));

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();